import React, { useState, useEffect } from 'react';
import './SplashScreen.css';

export default function SplashScreen({ onFinished }) {
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    const fadeTimer = setTimeout(() => setFadeOut(true), 3000);
    const removeTimer = setTimeout(() => onFinished(), 4000);
    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(removeTimer);
    };
  }, [onFinished]);

  return (
    <div className={`splash-screen ${fadeOut ? 'fade-out' : ''}`}>
      <img src="/logo.png" alt="Church Logo" className="splash-logo" />
      <div className="splash-title">St Barbara & St Noufer</div>
      <div className="splash-subtitle">Coptic Orthodox Church</div>
    </div>
  );
}
